module.exports = __webpack_public_path__ + "static/media/rightArrowIconWhite.0bb508ef.svg";